import { PureComponent } from 'react'
import cn from 'classnames'
import { string, shape, bool } from 'prop-types'

import IconSocialTwitter from './icon-social-twitter.js'
import IconSocialInstagram from './icon-social-instagram.js'
import IconSocialFacebook from './icon-social-facebook.js'
import IconSocialYoutube from './icon-social-youtube.js'
import IconSocialLinkedin from './icon-social-linkedin.js'
import IconSocialRss from './icon-social-rss.js'
import IconSocialTumblr from './icon-social-tumblr.js'
import IconArrowLeft from './icon-arrow-left.js'
import IconArrowRight from './icon-arrow-right.js'
import IconClose from './icon-close.js'
import IconSocialPinterest from './icon-social-pinterest.js'
import IconSocialTikTok from './icon-social-tiktok.js'
import IconComments from './icon-comments.js'
import IconLikes from './icon-likes.js'
import IconSubmit from './icon-submit.js'

export default class Icon extends PureComponent {
  static propTypes = {
    ariaHidden: bool,
    className: string,
    color: string,
    height: string,
    icon: string.isRequired,
    style: shape(),
    width: string,
  }

  static defaultProps = {
    className: '',
    color: '#000000',
    height: undefined,
    style: {},
    width: undefined,
  }

  render() {
    const { className, color, style, height, width, ariaHidden } = this.props
    const constructedClass = cn('bzfy-icon', `bzfy-icon--${this.props.icon}`, className)

    const minWidth = String(width > 32 ? width : 32)
    const minHeight = String(height > 32 ? height : 32)

    const icon = {
      'social-twitter': <IconSocialTwitter color={color} height={minHeight} width={minWidth} />,
      'social-instagram': <IconSocialInstagram color={color} height={minHeight} width={minWidth} />,
      'social-facebook': <IconSocialFacebook color={color} height={minHeight} width={minWidth} />,
      'social-youtube': <IconSocialYoutube height={minHeight} width={minWidth} />,
      'social-linkedin': <IconSocialLinkedin color={color} height={minHeight} width={minWidth} />,
      'social-rss': <IconSocialRss color={color} height={minHeight} width={minWidth} />,
      'social-tumblr': <IconSocialTumblr color={color} height={minHeight} width={minWidth} />,
      'social-pinterest': <IconSocialPinterest color={color} height={minHeight} width={minWidth} />,
      'social-tiktok': <IconSocialTikTok height={minHeight} width={minWidth} />,
      'arrow-left': <IconArrowLeft color={color} height={minHeight} width={minWidth} />,
      'arrow-right': <IconArrowRight color={color} height={minHeight} width={minWidth} />,
      likes: <IconLikes color={color} />,
      comments: <IconComments color={color} />,
      close: <IconClose color={color} />,
      submit: <IconSubmit color={color} />,
    }[this.props.icon]

    return icon ? (
      <div aria-hidden={ariaHidden ? 'true' : 'false'} className={constructedClass} style={style}>
        {icon}
      </div>
    ) : null
  }
}
